import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import Products from '../components/DashboardComponents/Products';
const BuyerDashboard = () => {
 return (
    <>
{/* <InnerBanner pageKey="buyerDashboard" /> */}

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <Products/> 
                </div>
               
            </div>
        </div>
      </section>
    </>
 );

};

export default BuyerDashboard;